module.exports = __webpack_public_path__ + "img/h.c60a58ba.jpg";